import React, { useState } from "react";
import "./10DBmanage.css";
import formFieldKeys from "./10formFields";

const VIP10DBmanage = ({ projectId }) => {
  const [downloading, setDownloading] = useState(false);

  // 데이터 다운로드 핸들러 (VIP11과 동일한 직접 백엔드 방식)
  const handleDownload = async (format = "csv") => {
    setDownloading(true);
    try {
      const formatName = format.toUpperCase();
      console.log(`VIP10 ${formatName} 다운로드 시작...`);

      // 배포 서버 호출 (Lambda 대신 직접 백엔드 사용)
      const downloadUrl = `https://product.idea2m.com/api/vip10/export?format=${format}`;

      console.log("다운로드 URL:", downloadUrl);
      console.log("요청 시작 시간:", new Date().toISOString());

      const acceptHeader =
        format === "excel"
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, */*"
          : "text/csv, application/csv, */*";

      const response = await fetch(downloadUrl, {
        method: "GET",
        headers: {
          Accept: acceptHeader,
        },
        mode: "cors",
        credentials: "omit",
      });

      console.log("응답 상태:", response.status, response.statusText);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("API 응답 에러:", errorText);
        throw new Error(
          `API 호출 실패: ${response.status} ${response.statusText}`
        );
      }

      console.log("응답 성공, Blob 생성 중...");

      // 파일 다운로드 처리
      const blob = await response.blob();
      console.log("Blob 크기:", blob.size, "바이트");

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // 파일명 추출 (Content-Disposition 헤더에서)
      const contentDisposition = response.headers.get("Content-Disposition");
      const defaultExtension = format === "excel" ? "xlsx" : "csv";
      let filename = `vip10_export.${defaultExtension}`;

      if (contentDisposition) {
        console.log("Content-Disposition:", contentDisposition);
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      console.log("다운로드 파일명:", filename);

      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      console.log(`${formatName} 파일 다운로드 완료:`, filename);
    } catch (error) {
      console.error(`${format.toUpperCase()} 다운로드 실패:`, error);

      let errorMessage = "다운로드 실패";
      if (error.name === "TypeError" && error.message.includes("fetch")) {
        errorMessage = "서버 연결 실패. 네트워크 상태를 확인해주세요.";
      } else if (error.message.includes("CORS")) {
        errorMessage =
          "CORS 정책으로 인한 요청 차단. 서버 설정을 확인해주세요.";
      } else {
        errorMessage = `다운로드 실패: ${error.message}`;
      }

      alert(errorMessage);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="vip-dbmanage-container">
      <div className="dbmanage-header">
        <h1>데이터 다운로드</h1>
        <p className="description">
          프로젝트의 전체 데이터를 다운로드할 수 있습니다.
          <br />
          <span className="form-keys-info">
            포함되는 필드 수: {formFieldKeys.length}개
          </span>
        </p>
      </div>

      <div className="download-options">
        <div className="download-card">
          <h3>CSV 형식 (.csv)</h3>
          <p>모든 데이터를 CSV 형식으로 다운로드합니다.</p>
          <button
            className="download-button csv"
            onClick={() => handleDownload("csv")}
            disabled={downloading}
          >
            {downloading ? "다운로드 중..." : "CSV 다운로드"}
          </button>
        </div>

        <div className="download-card">
          <h3>Excel 형식 (.xlsx)</h3>
          <p>모든 데이터를 Excel 형식으로 다운로드합니다.</p>
          <button
            className="download-button excel"
            onClick={() => handleDownload("excel")}
            disabled={downloading}
          >
            {downloading ? "다운로드 중..." : "Excel 다운로드"}
          </button>
        </div>
      </div>

      <div className="form-keys-section">
        <h3>포함되는 데이터 필드</h3>
        <div className="form-keys-list">
          {formFieldKeys.map((key, index) => (
            <div key={index} className="form-key-item">
              <span className="key">{key}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VIP10DBmanage;
